import React from 'react';
import * as util from '#packages/util';
import InfiniteEditingArea from './infiniteEditingArea';
import FixedEditingArea from './fixedEditingArea';

export interface EditingAreaOwnProps {
  leftBarAreaRef: React.RefObject<HTMLDivElement>;
}

const EditingArea: React.FC<EditingAreaOwnProps> = (props) => {
  return util.fixedStage.isFixedStageEnabled() ? (
    <FixedEditingArea leftBarAreaRef={props.leftBarAreaRef} />
  ) : (
    <InfiniteEditingArea leftBarAreaRef={props.leftBarAreaRef} />
  );
};

export default EditingArea;
